import React, { useEffect, useState } from "react";
import Heading from "../../common/heading/Heading";
import "./Hero.css";

const images = ["/images/bg.jpg", "/images/bg2.jpg", "/images/bg3.jpg"];

const Hero = () => {
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 4000); // 4 seconds change
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <section
        className="hero"
        style={{
          backgroundImage: `url(${images[currentImage]})`,
        }}
      >
        <div className="container">
          <div className="row">
            <Heading
              subtitle="WELCOME TO Girls Degree College Skardu."
              title="Online Admisison Portal"
            />
            <p></p>
            <div className="button">
              <button className="primary-btn">
                GET STARTED NOW <i className="fa fa-long-arrow-alt-right"></i>
              </button>
              <button>
                VIEW COURSE <i className="fa fa-long-arrow-alt-right"></i>
              </button>
            </div>
          </div>
        </div>
      </section>
      <div className="margin"></div>
    </>
  );
};

export default Hero;
